/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProducedMaterialCheckState {
  None = 'None',
  Enabled = 'Enabled',
  Disabled = 'Disabled',
  Mandatory = 'Mandatory'
}
